import { render, staticRenderFns } from "./KpiCardComponent.vue?vue&type=template&id=33441546&scoped=true&"
import script from "./KpiCardComponent.vue?vue&type=script&lang=js&"
export * from "./KpiCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./KpiCardComponent.vue?vue&type=style&index=0&id=33441546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33441546",
  null
  
)

export default component.exports